/** Shared Lenis instance for route scroll resets and programmatic scroll. */
let lenisRef = null;

export function setLenisInstance(instance) {
  lenisRef = instance;
}

export function getLenisInstance() {
  return lenisRef;
}

export function scrollToTop(options = { immediate: true }) {
  if (lenisRef) {
    lenisRef.scrollTo(0, options);
    return;
  }
  window.scrollTo(0, 0);
}
